import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { RegisterUserResultModel } from 'src/app/shared/models/registerUserResult.model';
import { PreRegistrationModel } from 'src/app/shared/models/pre-registration.model';
import { PreRegistrationValidationResult } from 'src/app/shared/models/pre-registration-validation.result.model';
import { Action_SetGDPRCOMPLIANCE } from 'src/app/shared/state/actions';
import { ErrorResponse } from 'src/app/shared/models/error.model';
import { Action_SetCurrentApplication } from '../state/actions';
import { ApplicationService } from 'src/app/shared/services/application.service';
import { CreatedStudentModel } from 'src/app/shared/models/created-student.model';
import { SingleResultApiResponse } from 'src/app/shared/models/api-response.model';
import { RegistrationService } from 'src/app/shared/services/registration.service';

@Component({
  selector: 'online-app-agent-student-registration-gdpr',
  templateUrl: './agent-student-registration-gdpr.component.html',
  styleUrls: ['./agent-student-registration-gdpr.component.scss'],
  host: {
    class:'application-component-after-login'
  }
})
export class AgentStudentRegistrationGdprComponent implements OnInit {

  constructor(private router: Router,
    private applicationService: ApplicationService,
    private registrationService: RegistrationService,
    private formBuilder: FormBuilder,
    private store: Store<any>) { }


    studentRegistrationGDPRFormGroup: FormGroup;
    isFormSubmitted = false;
    isGDPRAccepted = false;
    sharedStateSubscription: Subscription;
    createdStudent: RegisterUserResultModel;
    preRegistrationDetails: PreRegistrationModel;
    preRegistrationValidationResult: PreRegistrationValidationResult;

  ngOnInit() {

    this.sharedStateSubscription = this.store
      .pipe(select('shared'))
      .subscribe(sharedState => {
        if (sharedState) {
          this.preRegistrationDetails = sharedState.preRegistrationDetails;
          this.preRegistrationValidationResult = sharedState.preRegistrationValidationResult;

          if (!this.preRegistrationValidationResult || !this.preRegistrationValidationResult.IsGdprRequired) {
            this.router.navigate(['applications', 'agent-student-registration']);
          }

        } else {
          this.router.navigate(['applications', 'agent-student-registration']);
        }
      });

    this.studentRegistrationGDPRFormGroup = this.formBuilder.group({
      acceptGDPR: false
    });

  }


  acceptGDPRClicked() {
    this.isGDPRAccepted = !this.isGDPRAccepted;

    this.studentRegistrationGDPRFormGroup.patchValue({
      acceptGDPR: this.isGDPRAccepted
    });

    if (this.isGDPRAccepted ) {
      this.studentRegistrationGDPRFormGroup.get('acceptGDPR').setErrors(null);
    }

    this.studentRegistrationGDPRFormGroup.updateValueAndValidity();

  }

  acceptGDPR(): void {

    this.isFormSubmitted = true;
    const gdprAccepted = this.studentRegistrationGDPRFormGroup.get('acceptGDPR').value;

    if (gdprAccepted) {
      this.storeGDPRAcceptance();
      this.router.navigate(['/account-registration']);
      // this.router.navigateByUrl('/account-registration');
    } else {
      // this.preRegistrationGDPRFormGroup.get('acceptGDPR').setErrors({'gdprNotAccepted': 'true'});
    }

  }

  agreeGDPR() {
    this.storeGDPRAcceptance();
    this.createNewStudent(this.preRegistrationDetails);
  }

  createNewStudent(preRegistrationDetails: PreRegistrationModel) {

    let createdStudent = new CreatedStudentModel();
    
    this.registrationService.createStudent(preRegistrationDetails)
    .subscribe( (response: SingleResultApiResponse) => {
      createdStudent = response.Result as CreatedStudentModel;

      this.setGDPRCompliance();
      preRegistrationDetails.StudentNumber = createdStudent.StudentNumber
      this.createNewApplication(preRegistrationDetails);

    }, (errorResponse: ErrorResponse) => {
      console.log(errorResponse);
    });

  }

  setGDPRCompliance(): void {
    this.store.dispatch({
      type: Action_SetGDPRCOMPLIANCE,
      payload: true
    });
  }

  createNewApplication(preRegistrationDetails: PreRegistrationModel) {
        this.applicationService.createApplicationByAgent(preRegistrationDetails)
        .subscribe(response => {
          // this.setCurrentApplicationId(response.Result.ApplicationId);
          this.router.navigate(['/applications', `${response.Result.ApplicationId}`, 'edit', 'important-information']);
        }, err => {
          //console.log('error in creating new application');
          console.log(err);
        });

  }

  setCurrentApplicationId(currentApplicationId: number): void {
    this.store.dispatch({
      type: Action_SetCurrentApplication,
      payload: currentApplicationId
    });
  }



  disagreeGDPR() {
    this.router.navigate(['applications', 'agent-student-registration']);
  }

  storeGDPRAcceptance(): void {
    this.store.dispatch({
      type: Action_SetGDPRCOMPLIANCE,
      payload: true
    });
  }

  //show border when tab on link for accessibility
  linkTabAccessibility(event): void {
    event.style.outline = "1px solid black";
  }

  linkBlurAccessibility(event): void {
    event.style.outline = "";
  }
}
